import React from "react";
import { Form, Input, Card, Typography, Checkbox, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import AuthServ from "../service/AuthServ";
import "../css/loginAndSignUp.css";
import GlobalButton from "../util/GlobalButton";

const { Text } = Typography;

const SignUp = () => {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    console.log("Form Values:", values);
    try {
      const response = await AuthServ.register(values);
      console.log("Signup Success:", response);
      message.success("Signup successful!");
      navigate("/login");
    } catch (error) {
      console.error("Signup Error:", error);
      message.error(error.message || "Signup failed! Please try again.");
    }
  };

  return (
    <div className="login-container">
      <Card title="Create an Account" bordered={false} className="login-card">
        <Form
          name="signup"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          {/* First Name */}
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: "Please enter your first name!" }]}
          >
            <Input placeholder="Enter your first name" />
          </Form.Item>

          {/* Last Name */}
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: "Please enter your last name!" }]}
          >
            <Input placeholder="Enter your last name" />
          </Form.Item>

          {/* Email */}
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Enter a valid email!" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          {/* Phone */}
          <Form.Item
            label="Phone"
            name="phone"
            rules={[
              { required: true, message: "Please enter your phone number!" },
              { pattern: /^\d{10}$/, message: "Phone number must be exactly 10 digits!" }
            ]}
          >
            <Input placeholder="Enter your phone number" />
          </Form.Item>

          {/* Password */}
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: "Please enter your password!" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>

          {/* Agreement Checkbox */}
          <Form.Item
            name="agreement"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please read and agree to the terms')),
              },
            ]}
          >
            <Checkbox>
              I have read and agree to the <Link to="/terms-and-conditions" target="_blank">Terms & Conditions</Link> and <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>
            </Checkbox>
          </Form.Item>

          {/* Submit + Footer */}
          <Form.Item>
            <GlobalButton action="login" htmlType="submit" block>
              Sign Up
            </GlobalButton>

            <div className="login-footer" style={{ marginTop: 16 }}>
              <Text>
                Already have an account?{" "}
                <a href="/customer-login" className="login-link">
                  Login
                </a>
              </Text>
            </div>

            <div style={{ marginTop: 12 }}>
              <GlobalButton action="back" onClick={() => navigate(-1)}>
                ← Back
              </GlobalButton>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default SignUp;
